import { render, staticRenderFns } from "./GroupedBars.vue?vue&type=template&id=5041bf8c"
import script from "./GroupedBars.vue?vue&type=script&lang=js"
export * from "./GroupedBars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports